import React from 'react';
import cn from 'classnames';
const TextError = ({ text, className, style }) => {
  return (
    <div
      style={style}
      className={cn(
        'ant-form-item-explain ant-form-item-explain-error mt-10',
        className
      )}
    >
      {text}
    </div>
  );
};

export default TextError;
